import { render } from "./Profile.vue?vue&type=template&id=382b8816"
const script = {}

import exportComponent from "/Users/hlw/Documents/HBuilderProjects/menhu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__